import axios from 'axios'
import { RetentionPayable, PostRetentionPayable, UpdateRetentionPayable } from './interfaces'

const apiURL = process.env.REACT_APP_API_URL

// GET: /RetentionPayable - Get all retentions payable
export const getRetentionsPayable = async (): Promise<RetentionPayable[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/RetentionPayable`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data: RetentionPayable[] = response.data
  return data
}

// GET: /RetentionPayable/{id} - Get single retention payable by ID
export const getRetentionPayable = async (retentionPayableId: number): Promise<RetentionPayable> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/RetentionPayable/${retentionPayableId}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data: RetentionPayable = response.data
  return data
}

// GET: /RetentionPayable/job/{jobid} - Get all retentions payable for a specific job
export const getRetentionsPayableByJob = async (jobId: number): Promise<RetentionPayable[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/RetentionPayable/job/${jobId}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data: RetentionPayable[] = response.data
  return data
}

// POST: /RetentionPayable - Create a new retention payable
export const createRetentionPayable = async (retentionPayable: PostRetentionPayable): Promise<RetentionPayable> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/RetentionPayable`,
    method: 'post',
    data: {
      jobId: retentionPayable.jobId,
      description: retentionPayable.description,
      value: retentionPayable.value,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data: RetentionPayable = response.data
  return data
}

// PUT: /RetentionPayable/{id} - Update an existing retention payable
export const updateRetentionPayable = async (
  retentionPayableId: number,
  retentionPayable: UpdateRetentionPayable
): Promise<RetentionPayable> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/RetentionPayable/${retentionPayableId}`,
    method: 'put',
    data: {
      retentionPayableId: retentionPayable.retentionPayableId,
      jobId: retentionPayable.jobId,
      description: retentionPayable.description,
      value: retentionPayable.value,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data: RetentionPayable = response.data
  return data
}

// DELETE: /RetentionPayable/{id} - Delete a retention payable
export const deleteRetentionPayable = async (retentionPayableId: number): Promise<void> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  await axios({
    url: `https://${apiURL}/RetentionPayable/${retentionPayableId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
}
